import axios from 'axios';
import { authProvider } from '../../authProvider';

const domain = process.env.REACT_APP_BACKEND_URL || 'http://192.168.2.140:4501/api';

// The backend requires the Azure AD id token this app already signs in with. No
// scopes are requested in authProvider.js, so an id token is the only token there
// is. getIdToken() answers from the msal cache and renews only within five minutes
// of expiry, through the same silent renewal the login runs on every page load.
// With no account (development builds render without the AzureAD gate) the
// request goes out without a header and the backend answers 401.
const client = axios.create();

client.interceptors.request.use(async config => {
  if (authProvider.getAccount()) {
    try {
      const response = await authProvider.getIdToken();
      config.headers.Authorization = `Bearer ${response.idToken.rawIdToken}`;
    } catch (e) {
      // Renewal failed or redirected to login; the backend's 401 reaches handleError.
    }
  }
  return config;
});

// Error
const handleError = (error, errorRequest) => {
  return dispatch => {
    if (error.response && error.response.status === 401) {
      dispatch(errorRequest(`${error.response.statusText}, please refresh the page`));
    } else if (error.response) {
      dispatch(errorRequest(error.response.data.message));
    } else {
      dispatch(errorRequest(error.message));
    }
  };
};

// GET
export const get = (path, successRequest, errorRequest) => {
  return async dispatch => await client.get(domain + path)
    .then(response => dispatch(successRequest(response.data)))
    .catch(error => dispatch(handleError(error, errorRequest)));
};

// POST
export const post = (path, body, successRequest, errorRequest) => {
  return async dispatch => await client.post(domain + path, body)
    .then(response => dispatch(successRequest(response.data)))
    .catch(error => dispatch(handleError(error, errorRequest)));
};

// PATCH
export const patch = (path, body, successRequest, errorRequest) => {
  return async dispatch => await client.patch(domain + path, body)
    .then(response => dispatch(successRequest(response.data)))
    .catch(error => dispatch(handleError(error, errorRequest)));
};

// DELETE
export const del = (path, body, successRequest, errorRequest) => {
  return async dispatch => await client.delete(domain + path, { data: body })
    .then(response => dispatch(successRequest(response.data)))
    .catch(error => dispatch(handleError(error, errorRequest)));
};

